"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-context.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-context.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentContext = void 0;
const payment_ach_in_1 = require("./payment-ach-in");
const payment_ach_out_1 = require("./payment-ach-out");
const payment_atm_1 = require("./payment-atm");
const payment_card_1 = require("./payment-card");
const payment_card_payout_1 = require("./payment-card-payout");
const payment_cash_advance_funding_1 = require("./payment-cash-advance-funding");
const payment_cash_deposit_1 = require("./payment-cash-deposit");
const payment_cash_deposit_settlement_1 = require("./payment-cash-deposit-settlement");
const payment_check_deposit_1 = require("./payment-check-deposit");
const payment_check_deposit_settlement_1 = require("./payment-check-deposit-settlement");
const payment_credit_balance_1 = require("./payment-credit-balance");
const payment_credit_bill_invoice_1 = require("./payment-credit-bill-invoice");
const payment_credit_line_fee_1 = require("./payment-credit-line-fee");
const payment_crypto_1 = require("./payment-crypto");
const payment_fee_1 = require("./payment-fee");
const payment_funding_1 = require("./payment-funding");
const payment_funding_fee_1 = require("./payment-funding-fee");
const payment_gift_card_batch_settlement_1 = require("./payment-gift-card-batch-settlement");
const payment_gift_card_order_1 = require("./payment-gift-card-order");
const payment_installment_loan_1 = require("./payment-installment-loan");
const payment_offer_1 = require("./payment-offer");
const payment_offer_reference_1 = require("./payment-offer-reference");
const payment_p2p_1 = require("./payment-p2p");
const payment_points_1 = require("./payment-points");
const payment_points_redemption_reference_1 = require("./payment-points-redemption-reference");
const payment_points_reward_1 = require("./payment-points-reward");
const payment_referral_1 = require("./payment-referral");
const payment_savings_interest_1 = require("./payment-savings-interest");
const payment_savings_match_1 = require("./payment-savings-match");
const payment_settlement_1 = require("./payment-settlement");
const payment_stock_1 = require("./payment-stock");
const payment_subscription_1 = require("./payment-subscription");
const payment_transfer_1 = require("./payment-transfer");
const protobufPackage = 'com.step.common.proto';
function createBasePaymentContext() {
    return {
        card: undefined,
        settlement: undefined,
        transfer: undefined,
        funding: undefined,
        fundingFee: undefined,
        referral: undefined,
        p2p: undefined,
        achIn: undefined,
        achOut: undefined,
        atmWithdrawal: undefined,
        cashDeposit: undefined,
        cashDepositSettlement: undefined,
        offerReward: undefined,
        offerRewardReference: undefined,
        installmentLoan: undefined,
        fee: undefined,
        crypto: undefined,
        checkDeposit: undefined,
        checkDepositSettlement: undefined,
        cardPayout: undefined,
        stock: undefined,
        creditBillInvoice: undefined,
        creditBalancePayment: undefined,
        savingsInterest: undefined,
        points: undefined,
        pointsReward: undefined,
        pointsRedemptionReference: undefined,
        subscription: undefined,
        cashAdvanceFunding: undefined,
        savingsMatch: undefined,
        giftCardOrder: undefined,
        creditLineFee: undefined,
        giftCardSettlement: undefined,
    };
}
exports.PaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.card)) {
            message.card = payment_card_1.CardPaymentContext.fromJSON(object.card);
        }
        if (isSet(object.settlement)) {
            message.settlement = payment_settlement_1.SettlementPaymentContext.fromJSON(object.settlement);
        }
        if (isSet(object.transfer)) {
            message.transfer = payment_transfer_1.TransferPaymentContext.fromJSON(object.transfer);
        }
        if (isSet(object.funding)) {
            message.funding = payment_funding_1.FundingPaymentContext.fromJSON(object.funding);
        }
        if (isSet(object.fundingFee)) {
            message.fundingFee = payment_funding_fee_1.FundingFeePaymentContext.fromJSON(object.fundingFee);
        }
        if (isSet(object.referral)) {
            message.referral = payment_referral_1.ReferralRedemptionPaymentContext.fromJSON(object.referral);
        }
        if (isSet(object.p2p)) {
            message.p2p = payment_p2p_1.P2PPaymentContext.fromJSON(object.p2p);
        }
        if (isSet(object.achIn)) {
            message.achIn = payment_ach_in_1.AchInPaymentContext.fromJSON(object.achIn);
        }
        if (isSet(object.achOut)) {
            message.achOut = payment_ach_out_1.AchOutPaymentContext.fromJSON(object.achOut);
        }
        if (isSet(object.atmWithdrawal)) {
            message.atmWithdrawal = payment_atm_1.AtmWithdrawalContext.fromJSON(object.atmWithdrawal);
        }
        if (isSet(object.cashDeposit)) {
            message.cashDeposit = payment_cash_deposit_1.CashDepositPaymentContext.fromJSON(object.cashDeposit);
        }
        if (isSet(object.cashDepositSettlement)) {
            message.cashDepositSettlement = payment_cash_deposit_settlement_1.CashDepositSettlementContext.fromJSON(object.cashDepositSettlement);
        }
        if (isSet(object.offerReward)) {
            message.offerReward = payment_offer_1.OfferRewardPaymentContext.fromJSON(object.offerReward);
        }
        if (isSet(object.offerRewardReference)) {
            message.offerRewardReference = payment_offer_reference_1.OfferRewardPaymentReferenceContext.fromJSON(object.offerRewardReference);
        }
        if (isSet(object.installmentLoan)) {
            message.installmentLoan = payment_installment_loan_1.InstallmentLoanPaymentContext.fromJSON(object.installmentLoan);
        }
        if (isSet(object.fee)) {
            message.fee = payment_fee_1.FeePaymentContext.fromJSON(object.fee);
        }
        if (isSet(object.crypto)) {
            message.crypto = payment_crypto_1.CryptoPaymentContext.fromJSON(object.crypto);
        }
        if (isSet(object.checkDeposit)) {
            message.checkDeposit = payment_check_deposit_1.CheckDepositPaymentContext.fromJSON(object.checkDeposit);
        }
        if (isSet(object.checkDepositSettlement)) {
            message.checkDepositSettlement = payment_check_deposit_settlement_1.CheckDepositSettlementContext.fromJSON(object.checkDepositSettlement);
        }
        if (isSet(object.cardPayout)) {
            message.cardPayout = payment_card_payout_1.CardPayoutPaymentContext.fromJSON(object.cardPayout);
        }
        if (isSet(object.stock)) {
            message.stock = payment_stock_1.StockPaymentContext.fromJSON(object.stock);
        }
        if (isSet(object.creditBillInvoice)) {
            message.creditBillInvoice = payment_credit_bill_invoice_1.CreditBillInvoicePaymentContext.fromJSON(object.creditBillInvoice);
        }
        if (isSet(object.creditBalancePayment)) {
            message.creditBalancePayment = payment_credit_balance_1.CreditBalancePaymentContext.fromJSON(object.creditBalancePayment);
        }
        if (isSet(object.savingsInterest)) {
            message.savingsInterest = payment_savings_interest_1.SavingsInterestPaymentContext.fromJSON(object.savingsInterest);
        }
        if (isSet(object.points)) {
            message.points = payment_points_1.PointsRedemptionPaymentContext.fromJSON(object.points);
        }
        if (isSet(object.pointsReward)) {
            message.pointsReward = payment_points_reward_1.PointsRewardPaymentContext.fromJSON(object.pointsReward);
        }
        if (isSet(object.pointsRedemptionReference)) {
            message.pointsRedemptionReference = payment_points_redemption_reference_1.PointsRedemptionReferenceContext.fromJSON(object.pointsRedemptionReference);
        }
        if (isSet(object.subscription)) {
            message.subscription = payment_subscription_1.SubscriptionPaymentContext.fromJSON(object.subscription);
        }
        if (isSet(object.cashAdvanceFunding)) {
            message.cashAdvanceFunding = payment_cash_advance_funding_1.CashAdvanceFundingPaymentContext.fromJSON(object.cashAdvanceFunding);
        }
        if (isSet(object.savingsMatch)) {
            message.savingsMatch = payment_savings_match_1.SavingsMatchPaymentContext.fromJSON(object.savingsMatch);
        }
        if (isSet(object.giftCardOrder)) {
            message.giftCardOrder = payment_gift_card_order_1.GiftCardOrderPaymentContext.fromJSON(object.giftCardOrder);
        }
        if (isSet(object.creditLineFee)) {
            message.creditLineFee = payment_credit_line_fee_1.CreditLineFeePaymentContext.fromJSON(object.creditLineFee);
        }
        if (isSet(object.giftCardSettlement)) {
            message.giftCardSettlement = payment_gift_card_batch_settlement_1.GiftCardBatchSettlementContext.fromJSON(object.giftCardSettlement);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = payment_card_1.CardPaymentContext.toJSON(message.card);
        }
        if (message.settlement !== undefined) {
            obj.settlement = payment_settlement_1.SettlementPaymentContext.toJSON(message.settlement);
        }
        if (message.transfer !== undefined) {
            obj.transfer = payment_transfer_1.TransferPaymentContext.toJSON(message.transfer);
        }
        if (message.funding !== undefined) {
            obj.funding = payment_funding_1.FundingPaymentContext.toJSON(message.funding);
        }
        if (message.fundingFee !== undefined) {
            obj.fundingFee = payment_funding_fee_1.FundingFeePaymentContext.toJSON(message.fundingFee);
        }
        if (message.referral !== undefined) {
            obj.referral = payment_referral_1.ReferralRedemptionPaymentContext.toJSON(message.referral);
        }
        if (message.p2p !== undefined) {
            obj.p2p = payment_p2p_1.P2PPaymentContext.toJSON(message.p2p);
        }
        if (message.achIn !== undefined) {
            obj.achIn = payment_ach_in_1.AchInPaymentContext.toJSON(message.achIn);
        }
        if (message.achOut !== undefined) {
            obj.achOut = payment_ach_out_1.AchOutPaymentContext.toJSON(message.achOut);
        }
        if (message.atmWithdrawal !== undefined) {
            obj.atmWithdrawal = payment_atm_1.AtmWithdrawalContext.toJSON(message.atmWithdrawal);
        }
        if (message.cashDeposit !== undefined) {
            obj.cashDeposit = payment_cash_deposit_1.CashDepositPaymentContext.toJSON(message.cashDeposit);
        }
        if (message.cashDepositSettlement !== undefined) {
            obj.cashDepositSettlement = payment_cash_deposit_settlement_1.CashDepositSettlementContext.toJSON(message.cashDepositSettlement);
        }
        if (message.offerReward !== undefined) {
            obj.offerReward = payment_offer_1.OfferRewardPaymentContext.toJSON(message.offerReward);
        }
        if (message.offerRewardReference !== undefined) {
            obj.offerRewardReference = payment_offer_reference_1.OfferRewardPaymentReferenceContext.toJSON(message.offerRewardReference);
        }
        if (message.installmentLoan !== undefined) {
            obj.installmentLoan = payment_installment_loan_1.InstallmentLoanPaymentContext.toJSON(message.installmentLoan);
        }
        if (message.fee !== undefined) {
            obj.fee = payment_fee_1.FeePaymentContext.toJSON(message.fee);
        }
        if (message.crypto !== undefined) {
            obj.crypto = payment_crypto_1.CryptoPaymentContext.toJSON(message.crypto);
        }
        if (message.checkDeposit !== undefined) {
            obj.checkDeposit = payment_check_deposit_1.CheckDepositPaymentContext.toJSON(message.checkDeposit);
        }
        if (message.checkDepositSettlement !== undefined) {
            obj.checkDepositSettlement = payment_check_deposit_settlement_1.CheckDepositSettlementContext.toJSON(message.checkDepositSettlement);
        }
        if (message.cardPayout !== undefined) {
            obj.cardPayout = payment_card_payout_1.CardPayoutPaymentContext.toJSON(message.cardPayout);
        }
        if (message.stock !== undefined) {
            obj.stock = payment_stock_1.StockPaymentContext.toJSON(message.stock);
        }
        if (message.creditBillInvoice !== undefined) {
            obj.creditBillInvoice = payment_credit_bill_invoice_1.CreditBillInvoicePaymentContext.toJSON(message.creditBillInvoice);
        }
        if (message.creditBalancePayment !== undefined) {
            obj.creditBalancePayment = payment_credit_balance_1.CreditBalancePaymentContext.toJSON(message.creditBalancePayment);
        }
        if (message.savingsInterest !== undefined) {
            obj.savingsInterest = payment_savings_interest_1.SavingsInterestPaymentContext.toJSON(message.savingsInterest);
        }
        if (message.points !== undefined) {
            obj.points = payment_points_1.PointsRedemptionPaymentContext.toJSON(message.points);
        }
        if (message.pointsReward !== undefined) {
            obj.pointsReward = payment_points_reward_1.PointsRewardPaymentContext.toJSON(message.pointsReward);
        }
        if (message.pointsRedemptionReference !== undefined) {
            obj.pointsRedemptionReference = payment_points_redemption_reference_1.PointsRedemptionReferenceContext.toJSON(message.pointsRedemptionReference);
        }
        if (message.subscription !== undefined) {
            obj.subscription = payment_subscription_1.SubscriptionPaymentContext.toJSON(message.subscription);
        }
        if (message.cashAdvanceFunding !== undefined) {
            obj.cashAdvanceFunding = payment_cash_advance_funding_1.CashAdvanceFundingPaymentContext.toJSON(message.cashAdvanceFunding);
        }
        if (message.savingsMatch !== undefined) {
            obj.savingsMatch = payment_savings_match_1.SavingsMatchPaymentContext.toJSON(message.savingsMatch);
        }
        if (message.giftCardOrder !== undefined) {
            obj.giftCardOrder = payment_gift_card_order_1.GiftCardOrderPaymentContext.toJSON(message.giftCardOrder);
        }
        if (message.creditLineFee !== undefined) {
            obj.creditLineFee = payment_credit_line_fee_1.CreditLineFeePaymentContext.toJSON(message.creditLineFee);
        }
        if (message.giftCardSettlement !== undefined) {
            obj.giftCardSettlement = payment_gift_card_batch_settlement_1.GiftCardBatchSettlementContext.toJSON(message.giftCardSettlement);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentContext();
        message.card = (object.card !== undefined && object.card !== null)
            ? payment_card_1.CardPaymentContext.fromPartial(object.card)
            : undefined;
        message.settlement = (object.settlement !== undefined && object.settlement !== null)
            ? payment_settlement_1.SettlementPaymentContext.fromPartial(object.settlement)
            : undefined;
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? payment_transfer_1.TransferPaymentContext.fromPartial(object.transfer)
            : undefined;
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? payment_funding_1.FundingPaymentContext.fromPartial(object.funding)
            : undefined;
        message.fundingFee = (object.fundingFee !== undefined && object.fundingFee !== null)
            ? payment_funding_fee_1.FundingFeePaymentContext.fromPartial(object.fundingFee)
            : undefined;
        message.referral = (object.referral !== undefined && object.referral !== null)
            ? payment_referral_1.ReferralRedemptionPaymentContext.fromPartial(object.referral)
            : undefined;
        message.p2p = (object.p2p !== undefined && object.p2p !== null)
            ? payment_p2p_1.P2PPaymentContext.fromPartial(object.p2p)
            : undefined;
        message.achIn = (object.achIn !== undefined && object.achIn !== null)
            ? payment_ach_in_1.AchInPaymentContext.fromPartial(object.achIn)
            : undefined;
        message.achOut = (object.achOut !== undefined && object.achOut !== null)
            ? payment_ach_out_1.AchOutPaymentContext.fromPartial(object.achOut)
            : undefined;
        message.atmWithdrawal = (object.atmWithdrawal !== undefined && object.atmWithdrawal !== null)
            ? payment_atm_1.AtmWithdrawalContext.fromPartial(object.atmWithdrawal)
            : undefined;
        message.cashDeposit = (object.cashDeposit !== undefined && object.cashDeposit !== null)
            ? payment_cash_deposit_1.CashDepositPaymentContext.fromPartial(object.cashDeposit)
            : undefined;
        message.cashDepositSettlement =
            (object.cashDepositSettlement !== undefined && object.cashDepositSettlement !== null)
                ? payment_cash_deposit_settlement_1.CashDepositSettlementContext.fromPartial(object.cashDepositSettlement)
                : undefined;
        message.offerReward = (object.offerReward !== undefined && object.offerReward !== null)
            ? payment_offer_1.OfferRewardPaymentContext.fromPartial(object.offerReward)
            : undefined;
        message.offerRewardReference =
            (object.offerRewardReference !== undefined && object.offerRewardReference !== null)
                ? payment_offer_reference_1.OfferRewardPaymentReferenceContext.fromPartial(object.offerRewardReference)
                : undefined;
        message.installmentLoan =
            (object.installmentLoan !== undefined && object.installmentLoan !== null)
                ? payment_installment_loan_1.InstallmentLoanPaymentContext.fromPartial(object.installmentLoan)
                : undefined;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? payment_fee_1.FeePaymentContext.fromPartial(object.fee)
            : undefined;
        message.crypto = (object.crypto !== undefined && object.crypto !== null)
            ? payment_crypto_1.CryptoPaymentContext.fromPartial(object.crypto)
            : undefined;
        message.checkDeposit = (object.checkDeposit !== undefined && object.checkDeposit !== null)
            ? payment_check_deposit_1.CheckDepositPaymentContext.fromPartial(object.checkDeposit)
            : undefined;
        message.checkDepositSettlement =
            (object.checkDepositSettlement !== undefined && object.checkDepositSettlement !== null)
                ? payment_check_deposit_settlement_1.CheckDepositSettlementContext.fromPartial(object.checkDepositSettlement)
                : undefined;
        message.cardPayout = (object.cardPayout !== undefined && object.cardPayout !== null)
            ? payment_card_payout_1.CardPayoutPaymentContext.fromPartial(object.cardPayout)
            : undefined;
        message.stock = (object.stock !== undefined && object.stock !== null)
            ? payment_stock_1.StockPaymentContext.fromPartial(object.stock)
            : undefined;
        message.creditBillInvoice =
            (object.creditBillInvoice !== undefined && object.creditBillInvoice !== null)
                ? payment_credit_bill_invoice_1.CreditBillInvoicePaymentContext.fromPartial(object.creditBillInvoice)
                : undefined;
        message.creditBalancePayment =
            (object.creditBalancePayment !== undefined && object.creditBalancePayment !== null)
                ? payment_credit_balance_1.CreditBalancePaymentContext.fromPartial(object.creditBalancePayment)
                : undefined;
        message.savingsInterest =
            (object.savingsInterest !== undefined && object.savingsInterest !== null)
                ? payment_savings_interest_1.SavingsInterestPaymentContext.fromPartial(object.savingsInterest)
                : undefined;
        message.points = (object.points !== undefined && object.points !== null)
            ? payment_points_1.PointsRedemptionPaymentContext.fromPartial(object.points)
            : undefined;
        message.pointsReward = (object.pointsReward !== undefined && object.pointsReward !== null)
            ? payment_points_reward_1.PointsRewardPaymentContext.fromPartial(object.pointsReward)
            : undefined;
        message.pointsRedemptionReference =
            (object.pointsRedemptionReference !== undefined && object.pointsRedemptionReference !== null)
                ? payment_points_redemption_reference_1.PointsRedemptionReferenceContext.fromPartial(object.pointsRedemptionReference)
                : undefined;
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? payment_subscription_1.SubscriptionPaymentContext.fromPartial(object.subscription)
            : undefined;
        message.cashAdvanceFunding =
            (object.cashAdvanceFunding !== undefined && object.cashAdvanceFunding !== null)
                ? payment_cash_advance_funding_1.CashAdvanceFundingPaymentContext.fromPartial(object.cashAdvanceFunding)
                : undefined;
        message.savingsMatch = (object.savingsMatch !== undefined && object.savingsMatch !== null)
            ? payment_savings_match_1.SavingsMatchPaymentContext.fromPartial(object.savingsMatch)
            : undefined;
        message.giftCardOrder = (object.giftCardOrder !== undefined && object.giftCardOrder !== null)
            ? payment_gift_card_order_1.GiftCardOrderPaymentContext.fromPartial(object.giftCardOrder)
            : undefined;
        message.creditLineFee = (object.creditLineFee !== undefined && object.creditLineFee !== null)
            ? payment_credit_line_fee_1.CreditLineFeePaymentContext.fromPartial(object.creditLineFee)
            : undefined;
        message.giftCardSettlement =
            (object.giftCardSettlement !== undefined && object.giftCardSettlement !== null)
                ? payment_gift_card_batch_settlement_1.GiftCardBatchSettlementContext.fromPartial(object.giftCardSettlement)
                : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-context.js.map